import * as R from 'ramda'
import {OrderExportPreview} from './OrderExportPreview'

export interface OrderExportSelection {
    readonly orders: number[],
    readonly positions: number[] | null,
}

export function fromExportPreview(
    exportPreview: OrderExportPreview,
): OrderExportSelection {
    const orders =
        R.map(
            orderRow => orderRow.orderWithOwners.order.id,
            R.filter(
                orderRow => orderRow.selected,
                exportPreview.orderRows.items,
            ),
        )
    switch (exportPreview.type) {
        case 'CompactPreview':
            return {
                orders,
                positions: null,
            }
        case 'DetailedPreview':
            return {
                orders,
                positions:
                    R.map(
                        positionRow => positionRow.position.id,
                        R.filter(
                            positionRow => positionRow.selected,
                            R.chain(
                                orderRow => orderRow.positionRows,
                                exportPreview.orderRows.items,
                            ),
                        ),
                    ),
            }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/OrderExportSelection.ts